import { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useQuery } from 'hooks'

const useScrollToTop = () => {
    const { pathname } = useLocation();
    const query = useQuery({ param: 'page' });

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });

    }, [pathname, query]);

    return true;
}

export default useScrollToTop;
